import {useLocation} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Input,
    Typography
} from "@mui/material";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import ButtonExit from "../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import FormControlLabel from "@mui/material/FormControlLabel";
import UtilityNewsService from "../../../API/admin/UtilityNewsService";
import UtilityPromotionService from "../../../API/admin/UtilityPromotionService";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const NewsSettings = ({
                          itemId, handleModalAlert, isModal, selectedString,
                          setSelectedString,
                      }) => {
    const api = itemId === "news" ? UtilityNewsService : UtilityPromotionService
    const initValue = {
        text: "",
        description: "",
        themeId: "",
        priority: 0,
        priorityRelevant: null,
        priorityPopular: null
    }
    const pathname = useLocation().pathname
    const [data, setData] = useState([]);
    const [themes, setThemes] = useState([]);
    const [isRelevant, setIsRelevant] = useState(true);
    const [isPopular, setIsPopular] = useState(true);
    const [currentTheme, setCurrentTheme] = useState({theme: ""});
    const [modal, setModal] = useState(false);
    const [bigImage, setBigImage] = useState(null);
    const [currentEditRowData, setCurrentEditRowData] = useState(initValue);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 7,
        searchData: ""
    })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        itemId && currentTheme?.theme && api.get(tableOptions.pageIndex, tableOptions.pageSize, tableOptions.searchData, currentTheme?.theme, isRelevant, isPopular).then(function (response) {
            setData(response.data.content);
            setTableOptions((prev) => ({...prev, totalElements: response?.data.total}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [itemId, currentTheme, isRelevant, isPopular, tableOptions.searchData, tableOptions.pageIndex, tableOptions.pageSize]);

    useEffect(() => {
        getStartPageSize()
        itemId && api.getTheme().then(function (response) {
            setThemes(response.data);
            setCurrentTheme({theme: response.data[0]?.id})
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [itemId]);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}+${itemId}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}+${itemId}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const handleClose = () => {
        setModal(false)
        setCurrentEditRowData(initValue)
    }

    const handleUpdate = (values, file, theme, handleClose) => {
        setLoading(true)
        const newData = itemId === "news" ? {...values, themeNews: theme} : {...values, themePromotion: theme}
        api.update(newData, currentEditRowData.id)
            .then(function (response) {
                if (theme.id === currentTheme.theme) {
                    setData(prev => prev.map(el => el.id === response.data.id ? response.data : el))
                } else {
                    setData(prev => prev.filter(el => el.id !== response.data.id))
                    tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                }
                handleClose()
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))

    }

    const handleDelete = (row) => {
        api.delete(row.id)
            .then(function () {
                setData(prev => prev.filter(el => el.id !== row.id))
                tableOptionsHandle((prev) => ({...prev, totalElements: data.length - 1}))
                handleModalAlert("Данные удалены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            })
    };

    const handleSubmit = (values, file, theme, handleClose) => {
        setLoading(true)
        api.add(values, file, theme.id)
            .then(function (response) {
                if (theme.id === currentTheme.theme) {
                    setData(prev => [...prev, response.data])
                    tableOptionsHandle((prev) => ({...prev, totalElements: data.length + 1}))
                }
                handleClose()
                handleModalAlert("Данные добавлены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error)
            }).finally(() => setLoading(false))

    }

    const handleAdd = () => {
        setModal(true)
        setCurrentEditRowData(prev => ({...prev, themeId: themes[0]?.id}))
    }
    const handleEdit = (row) => {
        const priority = row.priorityRelevant !== null ? row.priorityRelevant : row.priorityPopular !== null ? row.priorityPopular : 0
        setCurrentEditRowData({
            ...row,
            priority: priority,
            themeId: itemId === "news" ? row.themeNews?.id : row.themePromotion?.id
        });
        setModal(true)
    };

    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Наименование', accessorKey: 'text', minSize: 200,
            },
            {
                header: 'Описание', accessorKey: 'description', minSize: 500,
            },
            {
                header: 'Дата', accessorKey: 'localDate', minSize: 100,
            },
            {
                header: 'Картинка', accessorKey: 'picture', minSize: 100,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return <Box sx={{
                        margin: "4px",
                        height: '100px',
                        width: "170px",
                        borderRadius: "8px",
                        backgroundImage: `url(${value.relativeUrlSmall})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        cursor: "pointer"
                    }}
                                onClick={() => setBigImage(value.relativeUrl)}/>
                },
            },
        ]
        if (isPopular && !isModal) {
            baseColumns.splice(6, 0, {
                id: 'priorityPopular',
                header: 'Приоритет популярных',
                accessorKey: 'priorityPopular',
                size: 220,
            });
        }
        if (isRelevant && !isModal) {
            baseColumns.splice(6, 0, {
                id: 'priorityRelevant',
                header: 'Приоритет актуальных',
                accessorKey: 'priorityRelevant',
                size: 220,
            });
        }

        return baseColumns;

    }, [data]);

    const menuItem = [
        {type: "edit", text: "Редактировать", handler: handleEdit},
        {type: "delete", text: "Удалить", handler: handleDelete}
    ]

    return (  <Box
        sx={{
            overflow: 'auto',
            maxWidth: 'calc(100vw - 410px)',
        }}
    >
        <Typography sx={{
            fontSize: "24px",
            fontWeight: 700,
            lineHeight: 1
        }}>{itemId === "news" ? "Настройки новостей" : "Настройки акций"}</Typography>
        <Box
            sx={{display: 'flex', justifyContent: "space-between", paddingTop: "30px"}}
        >
            <Box sx={{display: 'flex', gap: "20px"}}>
                <Box sx={{width: "300px"}}>
                    <TextFieldValidation
                        select
                        name="theme"
                        label="Тема"
                        margin={"none"}
                        disabled={!currentTheme.theme}
                        value={currentTheme?.theme}
                        setCurrValues={setCurrentTheme}
                    >
                        {themes.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.title}
                            </MenuItem>
                        ))}
                    </TextFieldValidation>
                </Box>
                <Box>
                    <FormControlLabel
                        control={<Checkbox
                            onChange={() => setIsRelevant(!isRelevant)}
                            checked={isRelevant}
                        />}
                        label="Актуальные"
                    />
                    <FormControlLabel
                        control={<Checkbox
                            onChange={() => setIsPopular(!isPopular)}
                            checked={isPopular}
                        />}
                        label="Популярные"
                    />
                </Box>
            </Box>
            {!isModal && <ButtonCreate
                text={"Добавить"}
                disabled={!currentTheme.theme}
                width={130}
                onClick={handleAdd}
            />}
        </Box>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}
            muiTableContainerProps={{
                sx: {
                    width: isRelevant && isPopular ? '1700px' : !isRelevant && !isPopular ? '1200px' : '1450px',
                    maxHeight: `calc(100vh - 420px)`
                }
            }}
            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "& td:after": {
                        "&:hover": {
                            backgroundColor: "red"
                        }
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                    "&:first-of-type": !isModal && {
                        padding: 0,
                        width: "50px",
                        height: "100px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: (theme) => theme.palette.text.light,
                        "& .MuiButtonBase-root": {
                            borderRadius: "4px",
                            width: "24px",
                            height: "24px",
                            opacity: 1,
                            margin: 0,
                            padding: 0,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            }
                        }
                    },
                    "& li": {
                        listStyleType: "none",
                        "& a": {
                            color: "#006CCC",
                            textDecoration: "none",
                            "&:hover": {
                                textDecoration: "underline"
                            }
                        }
                    }
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem"
                },
            }}
            muiTableBodyRowProps={({row}) => {

                return ({
                    onClick: () => isModal && setSelectedString(row.original),
                    sx: () => ({
                        height: '36px',
                        cursor: isModal && "pointer",
                        backgroundColor: row.original.id === selectedString?.id ? "#D7E8FA" : "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: row.original.id === selectedString?.id ? "#D7E8FA" : '#F5F6FA',
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-actions': {
                    header: "",
                    size: 3,
                    minSize: 3,
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            onGlobalFilterChange={value => tableOptionsHandle({...tableOptions, searchData: value})}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            initialState={{
                columnVisibility: {
                    id: false,
                    localDate: !isModal,
                    description: !isModal,
                },
            }}
            manualPagination={true}
            state={{showGlobalFilter: true, pagination: tableOptions}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                return (el.type === "edit" || (el.type === "delete" && !row.original.blocked)) && <MenuItem
                    key={el.type}
                    onClick={() => {
                        el.handler(row.original)
                        closeMenu();
                    }}
                    sx={{
                        margin: "0 8px",
                        borderRadius: "4px",
                        "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                    }}
                >
                    {el.text}
                </MenuItem>
            })}
            localization={MRT_Localization_RU}
            enableRowActions={!isModal}
            enableToolbarInternalActions={false}
        />
        <NewsSettingsModal
            title={currentEditRowData.id ? "Изменить" : "Добавить"}
            open={modal} onClose={handleClose}
            handleSubmit={currentEditRowData.id ? handleUpdate : handleSubmit}
            initValue={currentEditRowData}
            handleModalAlert={handleModalAlert}
            themes={themes}
            loading={loading}/>
        <BigImage bigImage={bigImage} setBigImage={setBigImage}></BigImage>
    </Box>);
};
const BigImage = ({bigImage, setBigImage}) => {
    return (
        <Dialog open={!!bigImage} PaperProps={{
            style: {
                minWidth: "810px",
                borderRadius: 8,
            }
        }}
        >
            <IconButton
                aria-label="close"
                onClick={() => setBigImage(null)}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 10,
                    top: 10,
                    width: 40,
                    height: 40,
                })}
            >
                <CloseIcon style={{fontSize: 24}}/>
            </IconButton>
            <Box sx={{
                margin: "4px",
                height: '600px',
                width: "800px",
                borderRadius: "8px",
                backgroundImage: `url(${bigImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
            }}/>
        </Dialog>)
}


const NewsSettingsModal = ({open, onClose, handleSubmit, initValue, title, handleModalAlert, themes,loading}) => {
    const [formState, setFormState] = useState({text: "", description: "", themeId: "", priority: 0})
    const [validationState, setValidationState] = useState({text: "", description: "", file: "", priority: ""})
    const typeNews = [{name: "Актуальные", type: "relevant"}, {name: "Популярные", type: "popular"}, {
        name: "Другое",
        type: "other"
    }]
    const [file, setFile] = useState(null)
    const [selectedType, setSelectedType] = useState(typeNews[0].type)

    useEffect(() => {
        setFormState(initValue)
        if (initValue.priorityPopular !== null) {
            setSelectedType("popular")
        } else if (initValue.priorityRelevant !== null) {
            setSelectedType("relevant")
        } else {
            setSelectedType("other")
        }
    }, [initValue])

    const handleClose = () => {
        setValidationState({text: "", description: "", file: "", priority: ""})
        setSelectedType(typeNews[0].type)
        onClose()
        setFile(null)
    }
    const handleValidationData = () => {
        const newErrors = {...validationState}

        Object.entries(formState).forEach(([name, value]) => {
            if (value === "" && name !== "file" && name !== "priority") {
                newErrors[name] = "пустое поле"
            }
            if (selectedType !== "other" && name === "priority" && value === "") {
                newErrors.priority = "Выберите другое либо введите приоритет"
            }
            if (!file && !initValue.id) {
                newErrors.file = "Прикрепите фаил"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            const res = {
                description: formState.description,
                text: formState.text,
                priorityPopular: selectedType === "popular" ? formState.priority : null,
                priorityRelevant: selectedType === "relevant" ? formState.priority : null
            }
            handleSubmit(res, file, themes.find(el => el.id === formState.themeId), handleClose)
        }
    }
    const handleFileSelect = (event) => {
        setFile(event.target.files[0]);
        setValidationState(prev => ({...prev, file: ""}))
    };

    return (
        <Dialog open={open} PaperProps={{
            style: {
                minWidth: "470px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent>
                <TextFieldValidation
                    name={"text"}
                    value={formState?.text}
                    label="Наименование"
                    setCurrValues={setFormState}
                    validationError={validationState?.text}
                    setValidationState={setValidationState}
                />
                <TextFieldValidation
                    name={"description"}
                    value={formState?.description}
                    label="Описание"
                    setCurrValues={setFormState}
                    validationError={validationState?.description}
                    setValidationState={setValidationState}
                />
                <TextFieldValidation
                    select
                    name="themeId"
                    label="Тема"
                    value={formState?.themeId}
                    setCurrValues={setFormState}
                >
                    {themes.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.title}
                        </MenuItem>
                    ))}
                </TextFieldValidation>
                <RadioGroup
                    defaultValue="female"
                    aria-labelledby="demo-customized-radios"
                    name="customized-radios"
                    value={selectedType}
                    onChange={(event) => setSelectedType(event.target.value)}
                >
                    <Box sx={{display: "flex"}}>
                        {typeNews.map((option) => (
                                <FormControlLabel
                                    key={option.type}
                                    value={option.type}
                                    control={<Radio/>}
                                    label={option.name}
                                    disabled={option.disabled}
                                    sx={{
                                        margin: 0,
                                        height: "36px",
                                        "&:not(:last-of-type)": {
                                            marginBottom: "4px",
                                        },
                                    }}
                                />
                            )
                        )}
                    </Box>
                </RadioGroup>
                {selectedType !== "other" && <TextFieldValidation
                    name={"priority"}
                    value={formState?.priority}
                    type={"number"}
                    label="Приоритет"
                    setCurrValues={setFormState}
                    validationError={validationState?.priority}
                    setValidationState={setValidationState}
                />}
                {!initValue?.id && <Box sx={{display: "flex", alignItems: "center", gap: "16px"}}>
                    <label htmlFor={`input`}
                           style={{
                               cursor: "pointer",
                               display: "flex",
                               alignItems: "center",
                               gap: "8px"
                           }}>
                        <AttachFileIcon
                            fontSize="small"
                            sx={{
                                color: (theme) => theme.palette.primary.dark,
                                transform: 'rotate(45deg)',
                            }}/>
                        <Typography sx={{color: (theme) => theme.palette.primary.dark}}>
                            Прикрепить файл</Typography>
                    </label>
                    <Input id={`input`} sx={{display: "none"}} type="file"
                           onChange={handleFileSelect}/>
                    <Typography
                        sx={{fontSize: "16px"}}>
                        {file?.name}
                    </Typography>
                    <Typography
                        sx={{fontSize: "16px", color: (theme) => theme.palette.error.light}}>
                        {validationState.file}
                    </Typography>
                </Box>}
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd loading={loading} text={initValue?.id ? "Изменить" : "Добавить"} onClick={handleValidationData}/>
            </DialogActions>
        </Dialog>
    );
}
export default NewsSettings;